import React from "react";

function CreateTicket() {
  return (
    <div className="container">

      {/* Heading */}
      <div className="row py-4 py-md-5 mt-4">
        <div className="col-12">
          <h1 className="fs-3 text-center text-md-start">
            To create a support ticket, select a relevant topic
          </h1>
        </div>
      </div>

      {/* Topics */}
      <div className="row">

        {/* Column 1 */}
        <div className="col-12 col-md-4 mb-4 px-3">
          <h4>
            <i className="fa-solid fa-circle-plus me-2"></i>
            Account Opening
          </h4>

          <div className="mt-3" style={{ lineHeight: "1.8" }}>
            <a href="#" className="d-block text-decoration-none">Online Account Opening</a>
            <a href="#" className="d-block text-decoration-none">Offline Account Opening</a>
            <a href="#" className="d-block text-decoration-none">Company / Partnership / HUF Account</a>
            <a href="#" className="d-block text-decoration-none">NRI Account Openings</a>
            <a href="#" className="d-block text-decoration-none">Charges at Zerodha</a>
            <a href="#" className="d-block text-decoration-none">3-in-1 Account</a>
            <a href="#" className="d-block text-decoration-none">Getting Started</a>
          </div>
        </div>

        {/* Column 2 */}
        <div className="col-12 col-md-4 mb-4 px-3">
          <h4>
            <i className="fa-solid fa-circle-plus me-2"></i>
            Your Account
          </h4>

          <div className="mt-3" style={{ lineHeight: "1.8" }}>
            <a href="#" className="d-block text-decoration-none">Login credentials</a>
            <a href="#" className="d-block text-decoration-none">Account modification</a>
            <a href="#" className="d-block text-decoration-none">DP ID & bank details</a>
            <a href="#" className="d-block text-decoration-none">Your profile</a>
            <a href="#" className="d-block text-decoration-none">Transfer of shares</a>
          </div>
        </div>

        {/* Column 3 */}
        <div className="col-12 col-md-4 mb-4 px-3">
          <h4>
            <i className="fa-solid fa-circle-plus me-2"></i>
            Support & Help
          </h4>

          <div className="mt-3" style={{ lineHeight: "1.8" }}>
            <a href="#" className="d-block text-decoration-none">Raise a ticket</a>
            <a href="#" className="d-block text-decoration-none">Track requests</a>
            <a href="#" className="d-block text-decoration-none">FAQs</a>
            <a href="#" className="d-block text-decoration-none">Contact support</a>
          </div>
        </div>

      </div>

    </div>
  );
}

export default CreateTicket;